import { differenceInMinutes, minutesToMilliseconds } from 'date-fns'
import { AvailabilityConstraintUpsertRequest } from 'types'
import { DtoCalendarConstraint } from 'components/AvailabilityConstraints/types'
import { AvailabilityType } from '@constants/availabilityType'
import { RRule } from 'rrule'
import { NEVER_FREQUENCY, RULE_FREQUENCY_DELIMITER, UTC_TIME_ZONE } from '../../constants'

// Make everything optional except for availability type
export type DtoConstraint = Partial<DtoCalendarConstraint> & {
  availabilityType: AvailabilityType
  dateStart: Date
}

const constraintToRecurrenceRule = ({
  recurrenceFrequency: ruleFrequency,
  dateStart: dtstart,
  dateStartTimeZone: tzid,
}: DtoConstraint): string => {
  const actualFrequency = ruleFrequency || NEVER_FREQUENCY
  const adjustedDtStart = new Date(dtstart.valueOf() - minutesToMilliseconds(dtstart.getTimezoneOffset()))

  const left = new RRule({
    dtstart: adjustedDtStart,
    tzid: tzid || UTC_TIME_ZONE,
  }).toString()

  const right = actualFrequency.replace(/;$/, '') // Trim trailing semicolon

  return `${left}${RULE_FREQUENCY_DELIMITER}${right}`
}

export const calendarConstraintEventToAvailabilityConstraintUpsertRequest = (
  constraint: DtoConstraint
): AvailabilityConstraintUpsertRequest => {
  const {
    appointmentTypes: tmpAppointmentTypes,
    availabilityType: availability_type,
    dateEnd: endTime,
    dateStart: startTime,
    isAllDay,
    deliveryModels,
  } = constraint

  const appointment_types = tmpAppointmentTypes && tmpAppointmentTypes?.length > 0 ? tmpAppointmentTypes : undefined
  const duration_in_minutes = endTime ? Math.max(0, differenceInMinutes(endTime, startTime)) : 0
  const recurrence_rule = constraintToRecurrenceRule(constraint)
  const delivery_models = deliveryModels?.length ? deliveryModels : []

  return {
    appointment_types,
    availability_type,
    delivery_models,
    duration_in_minutes,
    recurrence_rule,
    is_all_day: Boolean(isAllDay),
  }
}
